import { ReservationRoomPaxModel } from "../reservation/reservationData";

//#region Query

export class PaxFindByCAAMemberQuery
{
    caaMember: string = "";
    isMember: boolean = false;
}

export class PaxUpdateBody
{
    reservationCode: string = "";
    token: string = "";
    listPax: PaxUpdateBodyPax[] = [];

    constructor(p_ReservationCode: string, p_Token: string)
    {
        this.reservationCode = p_ReservationCode;
        this.token = p_Token;
        this.listPax = [];
    }
}

export class PaxUpdateBodyPax
{
    index: number = 0;

    address: string = "";
    allergies: string = "";
    birthDate: string = "";
    caaMember: string = "";
    city: string = "";
    email: string = "";
    firstName: string = "";
    gender: string = "";
    isCAAMember: boolean = false;
    lang: string = "EN";
    lastName: string = "";
    medicalCondition: string = "";
    postal: string = "";
    province: string = "";
    specialRequest: string = "";
    salutation: string = "";
    tel1: string = "";
    tel2: string = "";
    tel3: string = "";
    telExt: string = "";
    useSameAddress: boolean = false;

    constructor(p_Model: ReservationRoomPaxModel)
    {
        this.index = p_Model.index;
        this.address = p_Model.address;
        this.allergies = p_Model.allergies;
        this.birthDate = p_Model.birthDate;
        this.caaMember = p_Model.caaMember;
        this.city = p_Model.city;
        this.email = p_Model.email;
        this.firstName = p_Model.firstName;
        this.gender = p_Model.gender;
        this.isCAAMember = p_Model.isCAAMember;
        this.lang = p_Model.lang;
        this.lastName = p_Model.lastName;
        this.medicalCondition = p_Model.medicalCondition;
        this.postal = p_Model.postal;
        this.province = p_Model.province;
        this.specialRequest = p_Model.specialRequest;
        this.salutation = p_Model.salutation;
        this.tel1 = p_Model.tel1;
        this.tel2 = p_Model.tel2;
        this.tel3 = p_Model.tel3;
        this.telExt = p_Model.telExt;
        this.useSameAddress = p_Model.useSameAddress;
    }
}

//#endregion

//#region Model

export class PaxCAAModel
{
    code: string = "";

    address: string = "";
    allergies: string = "";
    birthDate: string = "";
    caaMember: string = "";
    city: string = "";
    email: string = "";
    firstName: string = "";
    fullName: string = "";
    gender: string = "";
    lastName: string = "";
    medicalCondition: string = "";
    postal: string = "";
    province: string = "";
    salutation: string = "";
    tel1: string = "";
    tel3: string = "";
}

//#endregion